<template>
  <div v-if="products.length > 0" class="mb-5 mt-5" style="">

    <div class="main-bg-img dessus"></div>

    <v-row class="mt-5 pt-2">
      <v-col cols="11" sm="10" class="px-0 mx-auto" style="z-index:1!important;">
        <h1 class="d-none">Galerie</h1>
        <div class="font-flower" style="font-size:60px;">
          <v-btn @click="goBack()" fab small color="grey darken-3"
                  title="retour à la page précédente">
            <v-icon color="white">mdi-arrow-left</v-icon>
          </v-btn> Boutique
        </div>
        <v-col cols="12" md="8">
          <p>Retrouvez l'ensemble des réalisations actuellement disponibles à la vente...
            <br><br>
          </p>
        </v-col>
        
        <h2 style="font-size:40px;"><v-icon>mdi-chevron-down</v-icon> Tableaux originaux</h2>
        <v-row>
          <template v-for="(product) in productsMandala">
            <v-col cols="6" sm="4" md="3" lg="2" class="pa-1 mt-5 text-center" :key="product.name">
              <router-link :to="'/product/'+product._id">
                <v-img class="mx-auto cursor-pointer" 
                      :class="product.isCircle ? 'img-rounded' : 'img-squarded'"
                      :aspect-ratio="1/1"
                      :src="baseUrl() + product.image"></v-img>
              </router-link>
                    <span class="font-dancing elipsis" style="font-size:25px;">{{ product.name }}</span><br>
                    <span class="font-dancing" style="font-size:18px;">{{ product.price }} €</span><br>
                    <span class="font-dancing" style="font-size:18px;">{{ product.dimension }}</span>
                    <!-- <br><small>{{ product.description.substr(0, 50) }}...</small> -->
            </v-col>
          </template>
        </v-row>

        <br><br><br><br><br>
        
        <template v-if="false && reproductions.length > 0">
          <h2 style="font-size:40px;"><v-icon>mdi-chevron-down</v-icon> Reproductions</h2>
          <p>Certaines de mes oeuvres peuvent être commandées sous forme de reproduction papier, ou sur toile...</p>
          <v-row class="mb-5">
            <template v-for="(product) in reproductions">
              <v-col cols="12" sm="6" md="6" lg="4" class=" mt-5 text-center" :key="product.name">
                <div class="reprocard">
                  <v-img class="mx-auto cursor-pointer" :class="product.isCircle ? 'img-rounded' : 'img-squarded'"
                        @click="openDialogProduct(product)" :aspect-ratio="1/1"
                        
                        :src="baseUrl() + product.image"></v-img>
                </div>
                <v-chip class="font-dancing elipsis labelrepro" style="">{{ product.name }}</v-chip><br>
              </v-col>
            </template>
          </v-row>
        </template>
        
      </v-col>
    </v-row>

    <v-dialog v-model="showProductDialog" v-if="productToShow != null"  
              :fullscreen="$vuetify.breakpoint.width < 700"
              transition="dialog-bottom-transition" max-width="600" scrollable>
      <DialogProduct :product="productToShow"></DialogProduct>
    </v-dialog>

  </div>
</template>

<script>
    import core from '../plugins/core.js'
    import router from "@/router/router"

    import DialogProduct from '@/components/main-layout/DialogProduct.vue'
    
    //import { i18n } from 'vue-lang-router';

    export default {
        name: "App",
        components: {
          DialogProduct
        },
        data: function () {
            return {
                products: [], 
                reproductions: [],
                productToShow: false,
                showProductDialog: false,
                flip: false
            };
        },
        mounted: function(){
          this.initData()
          this.$root.$on('closeDialogProduct', () => { this.closeDialogProduct() })
          this.$store.dispatch('app/incStat', '/shop')
        },
        methods: {
            
            async initData(){
              this.reproductions = await this.$store.dispatch('app/fetchEntities', 
                                        { entityType: "product", 
                                          query: { 
                                            reproductible : true,
                                            public: true } 
                                        })

              this.products = await this.$store.dispatch('app/fetchEntities', { entityType: "product", query: { stock : { '$gte' : 1 }, public: true } })
              //this.products = this.$store.state.app.data.product
              //console.log("products", this.products)
            },
            openDialogProduct(product){
              this.productToShow = product
              this.showProductDialog = true
            },
            closeDialogProduct(){
              this.productToShow = null
              this.showProductDialog = false
            },
            goBack(){ router.back() },

            baseUrl(){ return core.baseUrl() }
        },
        computed:{
          productsMandala(){ return this.products.filter((item) => { return item.categories[0] != null  })},
          productsRepro(){ return this.products.filter((item) => { return item.categories[0] != null && item.categories[0].name == 'Reproduction papier'  })}
        }
    };
</script>

<style>
  .img-rounded{
    border-radius:100%!important;
  }
  .img-rounded-dialog{
    border-radius:100%!important;
  }

  .reprocard{
    background-color: white;
    position: relative;
    padding: 20px;
    padding-bottom:40px;
    border-radius:3px;
  }
  .labelrepro{
    font-size:25px !important;
    padding: 20px !important;
    box-shadow: 0px 0px 10px -4px black;
    margin-top:-20px;
  }


    html,
    body {
        height: 100%;
        font-family: "Roboto";
    }

    .list1 {
        height: 100%;
    }

    .list2 {
        display: flex;
        height: 100%;
    }

    .chip {
        margin: 10px;
    }

    .drop-allowed.drop-in * {
        cursor: inherit !important;
    }
</style>
